import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOOD_API } from '@config/ws.config';
import { DoodCreateOrderQuery } from '@store/order/order.model';

export interface RecommendationsRequest {
  order: DoodCreateOrderQuery;
  marketplace: string;
  shop: string;
}

export interface RecommendationItem {
  type: string;
  data: unknown;
}

export interface RecommendationsResponse {
  recommendations: RecommendationItem[];
}

@Injectable({ providedIn: 'root' })
export class RecommendationsApiService {
  private readonly httpClient = inject(HttpClient);

  /**
   * Get product recommendations for the current order (revenue optimization plugin).
   */
  getRecommendations$(request: RecommendationsRequest) {
    return this.httpClient.post<RecommendationsResponse>(
      `${DOOD_API}/plugins/revenue-optimization/recommendations`,
      request,
    );
  }
}
